// extracted by mini-css-extract-plugin
module.exports = {"container":"OptionComponentCheckbox-module__container__1MtcM","label":"OptionComponentCheckbox-module__label__YFsox","ico":"OptionComponentCheckbox-module__ico__3AMAS"};